// Shared client for the contact / demo Cloud Run (Cloud Function) email handler.
// The function reads: fName, last_name, email, number, job_title, company,
// country, reason_for_inquiry, message. We also pass `subject` and `form_type`
// so the handler can vary the email subject per form.

export const CONTACT_FORM_ENDPOINT =
  process.env.REACT_APP_CONTACT_FORM_ENDPOINT ||
  "https://us-central1-dd-dev-webapp.cloudfunctions.net/contact-form-handler-dev";

// Split a single "Full Name" field into the first/last the handler expects.
const splitName = (fullName = "") => {
  const parts = fullName.trim().split(/\s+/);
  const fName = parts.shift() || "";
  const last_name = parts.join(" ");
  return { fName, last_name };
};

async function postForm(payload) {
  const response = await fetch(CONTACT_FORM_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  let result = {};
  try {
    result = await response.json();
  } catch (e) {
    // handler may return an empty body on success
  }

  if (!response.ok) {
    throw new Error(result.error || "Failed to send. Please try again.");
  }
  return result;
}

// Contact form → email
export function submitContactForm(values) {
  const { fName, last_name } = splitName(values.fullName);
  return postForm({
    fName,
    last_name,
    email: values.email,
    number: values.phone || "",
    job_title: "",
    company: values.company || "",
    country: "",
    reason_for_inquiry: values.topic || "General inquiry",
    message: values.message || "",
    subject: `New contact enquiry${values.topic ? `: ${values.topic}` : ""}`,
    form_type: "contact",
  });
}

// Request-a-demo form → email
export function submitDemoForm(values) {
  const { fName, last_name } = splitName(values.fullName);
  const help = Array.isArray(values.help) ? values.help : [];

  // The demo form has no free-text message, so summarise the answers into one.
  const message = [
    values.headcount ? `Company headcount: ${values.headcount}` : "",
    help.length ? `Areas of interest: ${help.join(", ")}` : "",
  ]
    .filter(Boolean)
    .join("\n");

  return postForm({
    fName,
    last_name,
    email: values.email,
    number: "",
    job_title: values.jobTitle || "",
    company: values.company || "",
    country: values.country || "",
    reason_for_inquiry: help.length ? help.join(", ") : "Demo request",
    message,
    company_headcount: values.headcount || "",
    subject: `New demo request${values.company ? ` from ${values.company}` : ""}`,
    form_type: "demo",
  });
}
